module.exports = {
	colors: {
		main: '#104fa0',
		sec: '#f58634',
		alt: '#104fa0',
	},

	showFunds: true,
	showBuses: true,
	useBusAssistantGPS: true,
	showHomeworks: true,
	showSchoolDay: true,
	useCourses: true,
	useUploadChatImage: false,

	about: {
		mobiles: ['+963993327106', '+963993327101'],
		phones: ['0212220752', '0212246760', '0212246760'],
		address: 'حلب - المحافظة - خلف مدرسة مريم',
		data: [36.205419, 37.142509],
		branches: [
			{
				name: 'حلب',
				location: {
					url: null,
					name: 'حلب - المحافظة - خلف مدرسة مريم'
				},
				numbers: [
					{ name: 'هاتف', phone: '+963993327106' },
					{ name: 'أرضي', landline: '0212246760' },
					{ name: null, phone: '+963993327106', landline: '0212246760' },
					{ name: null, landline: '0212246760' },
				],
			},
		],
		email: null,
		facebook: 'https://www.facebook.com/edunix.system',
		privacy: null,
		details: [
			{
				title: 'تطبيق إديونكس',
				content: [
					'يمكّن تطبيق الأهالي من متابعة سير الحركة التعليمية لأبنائهم والتواصل المباشر مع إدارة المؤسسة التعليمية وهو يعمل على نظامي Android وiOS',
					'كما يصمم وفقاً للهوية البصرية لمؤسستكم وينشر باسم المؤسسة التعليمية على المتاجر العالمية.',
				],
			},
		],
	},

	pwa: {
		name: 'Edunix',
		shortName: 'Edunix',
		description: 'Edunix app - portal version for edunix mobile app.',
	},
};
